{
	"paths": {
		"email": "E-mail",
		"password": "Password",
		"newPassword": "New Password",
		"repeatPassword": "Repeat Password",
		"username": "Username",
		"firstName": "First Name",
		"lastName": "Last Name",
		"emailOrUsername": "E-mail or Username",
		"telephone": "Phone"
	},
	"errors": {
		"at_least_numbers_with_value": "Must contain at least {{ minimum }} number",
		"at_least_numbers_with_path": "{{ path }} must contain at least {{ minimum }} number",
		"at_least_special_characters_with_value": "Must contain at least {{ minimum }} special characters",
		"at_least_special_characters_with_path": "{{ path }} must contain at least {{ minimum }} special characters",
		"only_letters_numbers_underscores": "Only letters, numbers, and underscores are allowed"
	}
}
